<svg #mySvg width="100" height="200" xmlns="http://www.w3.org/2000/svg" style="border: 1px solid #ccc;" class="edit-placeholder">
    <!-- Programmatically added text will appear here -->
    <rect 
        width="100%" 
        height="100%" 
        />
        <foreignObject x="0" y="0" width="100%" height="100%">
            <div 
                xmlns="http://www.w3.org/1999/xhtml" 
                style="width: 100%; font-size: 14px;"
                [ngStyle]="{ background: fillColor }"
                (mouseenter)="changeFillColor('#ccccccb3')"
                (mouseleave)="changeFillColor('#cccccc')">
              {{svgText}}
            </div>
        </foreignObject>
  </svg>

<!-- 
  <text x="50%" y="50%" font-size="20" text-anchor="middle" fill="#777777" dy=".3em">Placeholder</text>
   -->
